export default "/8522fe2631ecefb1e3967be9883671f05392a386/ce82aae38e929df8fcdd7e760ce92d73.svg";